import { render, staticRenderFns } from "./VehicleImages.vue?vue&type=template&id=60d8c2da&"
import script from "./VehicleImages.vue?vue&type=script&lang=js&"
export * from "./VehicleImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports